import { ONBOARDING_PAYMENT_CHOSEN } from '@heidi/growth/contracts';

/** Whether the marketing site asked for a plan other than the free one. */
export function isPaidPaymentChosen(
  paymentChosen: ONBOARDING_PAYMENT_CHOSEN | null | undefined
): paymentChosen is ONBOARDING_PAYMENT_CHOSEN {
  return !!paymentChosen && paymentChosen !== ONBOARDING_PAYMENT_CHOSEN.FREE;
}

/**
 * Carries a paid plan (and its `seat_type`) onto a post-signup redirect URL.
 * The free plan is the default on arrival, so it is left off.
 */
export function appendPaidPlanHashToRedirectUrl(
  redirectUrl: string,
  paymentChosen: ONBOARDING_PAYMENT_CHOSEN | null | undefined
): string {
  if (!isPaidPaymentChosen(paymentChosen)) return redirectUrl;
  return appendPaymentChosenHashToRedirectUrl(redirectUrl, paymentChosen);
}

/**
 * Appends paymentChosen as a hash param to the redirect URL (for onboarding).
 * Kept separate from attribution params since they use query params and this uses the hash.
 */
export function appendPaymentChosenHashToRedirectUrl(
  redirectUrl: string,
  paymentChosen: ONBOARDING_PAYMENT_CHOSEN
): string {
  if (typeof window === 'undefined') return redirectUrl;
  try {
    const resolvedUrl = new URL(redirectUrl, window.location.origin);
    const serialized = JSON.stringify(paymentChosen);
    const hashParams = new URLSearchParams(resolvedUrl.hash.slice(1));
    hashParams.set('paymentChosen', serialized);
    // Marketing puts `seat_type` next to `paymentChosen` on the current page.
    // The redirect URL is built fresh, so copy it across or the billing modal
    // cannot tell Clinician from Clinician Max.
    if (!hashParams.has('seat_type')) {
      const seatType = new URLSearchParams(window.location.hash.slice(1)).get(
        'seat_type'
      );
      if (seatType) hashParams.set('seat_type', seatType);
    }
    resolvedUrl.hash = hashParams.toString();
    if (/^https?:\/\//i.test(redirectUrl)) {
      return resolvedUrl.toString();
    }
    return `${resolvedUrl.pathname}${resolvedUrl.search}${resolvedUrl.hash}`;
  } catch {
    return redirectUrl;
  }
}
